<template lang="pug">
  .target.target-update
    e-modal(
      ref="modalForm"
      @confirm="chooseForm()"
      @close="closeForm()"
      :title="title"
      :hideDeleteButton="false"
    )
      slot
        e-form(:formValidator="formValidator")
          div.body-wrapper.cuscroll
            div
              div.body
                .danger-color
                  div(v-for="error in errors") {{ error }}
                div.col
                  e-form-group(
                    v-if="hasTargetsPresets"
                    name="name"
                    inputType="datalist"
                    :datalist="presets"
                    datalistName="presets"
                    label="Наименование"
                    :model="fields"
                    tabView="tab1"
                    :required="true"
                    placeholder=" "
                  )
                  e-form-group(
                    v-else
                    name="name"
                    inputType="textarea"
                    label="Наименование"
                    :model="fields"
                    tabView="tab1"
                    :required="true"
                    placeholder=" "
                  )
                  e-form-group(
                    name="measure_id"
                    inputType="select"
                    label="Единица измерения"
                    :model="fields"
                    tabView="tab1"
                    :options="measureTypes"
                    :required="true"
                  )
                  e-form-group(
                    name="source"
                    :inputStyle="{'max-width':'100%'}"
                    inputType="input"
                    label="Источник"
                    :model="fields"
                    tabView="tab1"
                  )
</template>

<script>
import { core, indicator } from '@/api/api-endpoints'
import targetForm from './mixins/target-form'
import { typeTable } from '@/mixins/targetMixin'
import hasMixin from '@/mixins/has-mixin'

export default {
  name: 'target-update',
  mixins: [targetForm, hasMixin],
  props: {
    isFromOperator: {
      type: Boolean,
      default: false,
    },
    tko_operator_id: {
      type: Number,
    },
  },
  data: () => ({
    checkedId: 0,
    presets: [],
    errors: [],
  }),
  computed: {
    pointMeasureId() {
      return this.measureTypes.find((item) => item.name.includes('шт')).id
    },
  },
  methods: {
    getItemEndpoint(route) {
      return indicator.objectUpdateOrCreate({
        query: {
          id: route.params.id,
          type_table: typeTable.TARGETS_TABLE,
        },
      })
    },
    getUpdateOrCreateUrl() {
      if (this.$route.params.id) {
        return indicator.objectUpdateOrCreate({
          query: {
            id: this.$route.params.id,
          },
        })
      }
      return indicator.objectUpdateOrCreate({
        query: {},
      })
    },
    getCollectionEndpoint() {
      return core.collection('measure', {
        query: {
          type: 'indicator',
        },
      })
    },
    getCollectionEndpointTypeTable() {
      return core.collection('type_table', {
        query: {
          type: 'indicator',
        },
      })
    },
    chooseForm() {
      this.isFromOperator ? this.saveOperatorForm() : this.saveForm()
    },
    async saveOperatorForm() {
      let urlData = indicator.objectUpdateOrCreate()
      let model = 'createModel'

      if (this.checkedId != 0) {
        urlData = indicator.objectUpdateOrCreate(this.checkedId)
        model = 'updateModel'
      }
      try {
        await this.$store.dispatch(model, {
          url: urlData,
          data: {
            name: this.fields.name,
            measure_id: this.pointMeasureId,
            source: this.fields.source,
            start_year: this.fields.start_year,
            end_year: this.fields.end_year,
            tko_operator_id: this.$route.params.id || this.tko_operator_id,
            type_table: typeTable.OPERATOR_TABLE,
          },
        })
        this.closeForm()
        this.errors = []
      } catch (e) {
        Object.values(e.data.errors).forEach((error) => {
          this.errors.push(error)
        })
      }
    },
    async getPresets() {
      this.presets = (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: indicator.preset(),
        })
      ).data.data
    },
  },
  created() {
    if (this.isFromOperator) {
      this.fields.measure_id = this.pointMeasureId
    }
    if (this.hasTargetsPresets) {
      this.getPresets()
    }
    this.fields.type_table =
      localStorage.getItem('typeTable') || typeTable.TARGETS_TABLE
  },
}
</script>
